export const types = {
  SET_ACTIVE_VABARRAY: 'SET_ACTIVE_VABARRAY',
};

export const setActiveVABArray_AC = (activeVabArray: string) => {
  return {
    type: types.SET_ACTIVE_VABARRAY,
    payload: {
      vabArrayValue: activeVabArray,
    },
  };
};
